import {Component} from 'react'
import {v4 as uuid} from 'uuid'

import Tags from '../Tags'
import Tasks from '../Tasks'

import './index.css'

const tagsList = [
  {optionId: 'HEALTH', displayText: 'Health'},
  {optionId: 'EDUCATION', displayText: 'Education'},
  {optionId: 'ENTERTAINMENT', displayText: 'Entertainment'},
  {optionId: 'SPORTS', displayText: 'Sports'},
  {optionId: 'TRAVEL', displayText: 'Travel'},
  {optionId: 'OTHERS', displayText: 'Others'},
]

class MyTasks extends Component {
  state = {
    taskName: '',
    tagName: tagsList[0].optionId,
    myTaskList: [],
    activeTag: '',
  }

  onclickTag = id => {
    this.setState(prev => ({
      activeTag: prev.activeTag === id ? '' : id,
    }))
  }

  onSubmit = event => {
    event.preventDefault()
    const {taskName, tagName} = this.state

    if (taskName === '') {
      return
    }

    const taskDetails = {id: uuid(), taskName, tagName}

    this.setState(prevState => ({
      taskName: '',
      tagName: tagsList[0].optionId,
      myTaskList: [...prevState.myTaskList, taskDetails],
    }))
  }

  onChangeTaskName = e => {
    this.setState({taskName: e.target.value})
  }

  onChangeTag = e => {
    this.setState({tagName: e.target.value})
  }

  renderTaskField = () => {
    const {taskName} = this.state
    return (
      <div className="inputFieldContainer">
        <label htmlFor="task" className="title">
          Task
        </label>
        <input
          type="text"
          id="task"
          value={taskName}
          placeholder="Enter the task here"
          onChange={this.onChangeTaskName}
          className="inputField"
        />
      </div>
    )
  }

  renderTagsField = () => {
    const {tagName} = this.state
    return (
      <div className="inputFieldContainer">
        <label htmlFor="tags" className="title">
          Tags
        </label>
        <select
          id="tags"
          className="inputField"
          value={tagName}
          onChange={this.onChangeTag}
        >
          {tagsList.map(tag => (
            <option key={tag.optionId} value={tag.optionId}>
              {tag.displayText}
            </option>
          ))}
        </select>
      </div>
    )
  }

  render() {
    const {myTaskList, activeTag} = this.state
    const filteredList =
      activeTag === ''
        ? myTaskList
        : myTaskList.filter(task => task.tagName === activeTag)

    return (
      <div className="appContainer">
        <div className="creatingTask">
          <h1 className="mainHeading">Create a Task!</h1>
          <form className="formContainer" onSubmit={this.onSubmit}>
            {this.renderTaskField()}
            {this.renderTagsField()}
            <button type="submit" className="submitBtn">
              Add Task
            </button>
          </form>
        </div>

        <div className="createdTasks">
          <h1 className="heading">Tags</h1>
          <ul className="tagButtons">
            {tagsList.map(tag => (
              <Tags
                key={tag.optionId}
                tagDetails={tag}
                activeTag={activeTag}
                onclickTag={this.onclickTag}
              />
            ))}
          </ul>

          <h1 className="heading">Tasks</h1>
          {filteredList.length > 0 ? (
            <ul className="myTasks">
              {filteredList.map(task => (
                <Tasks key={task.id} taskDetails={task} />
              ))}
            </ul>
          ) : (
            <p className="noTasks">No Tasks Added Yet</p>
          )}
        </div>
      </div>
    )
  }
}

export default MyTasks
